import '../../../../filters';
import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
import { DateTime } from 'luxon';

export default {
  name: 'OmJobcard',
  components: {
    datetime: Datetime,
    DateTime,
    DetailsComp: require('./details.vue').default,
    StepsComp: require('./steps.vue').default,
    BudgetsComp: require('./budgets.vue').default,
    ManpowersComp: require('./manpowers.vue').default,
    SupportsComp: require('./supports.vue').default,
    StoresComp: require('./stores.vue').default,
    ConsumablesComp: require('./consumables.vue').default,
    AttachmentsComp: require('./attachments.vue').default
    /*HyperlinksComp: require('./hyperlinks.vue').default,*/
  },
  props: ['dataObj'],
  data: function () {
    return {
      currentPage: 'details',
      message: ''
    };
  },
  created() {
    console.log('job card data', this.dataObj.appData);
    /*    this.showRates();*/
  },
  methods: {
    //showRates: function () {
    //  if (this.$store.state.isFieldWorker)
    //    this.dataObj.appData.settings.showSupportServicesRates = false;

    //  if (this.$store.state.isFieldWorker)
    //    this.dataObj.appData.settings.showManpowerRates = false;

    //},
    gotoPage(page) {
      this.currentPage = page;
    }
  }
};
